export default "__VITE_ASSET__591b2e5d__"